export default string =>
  string
    .split('')
    .reduce(
      (hash, i) =>
        (
          ((hash << 5) - hash) + i.charCodeAt(0)
        ) | 0,
      0)
